import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { FILTER } from '../../../../constants/staticContent';
import { ReactComponent as FilterIcon } from '../../../../assets/common-assets/filter.svg';
import { ReactComponent as SortIcon } from '../../../../assets/common-assets/sort.svg';
import { classes, Root } from './utils';
import CustomTooltip from '../../utils/CustomTooltip';

const ResetAndApplyButton = (props) => {
  const { handleApplyFilter, handleResetSort } = props;
  return (
    <Root>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CustomTooltip title={FILTER.APPLY_FILTER}>
          <Button
            variant="contained"
            onClick={handleApplyFilter}
            className={classes.applyAndReset}
          >
            <FilterIcon className={classes.uploadIcon} />
            <Typography variant="body1" className={classes.buttonsTypo}>
              {FILTER.APPLY_FILTER}
            </Typography>
          </Button>
        </CustomTooltip>

        <CustomTooltip title={FILTER.RESET_SORT}>
          <Button
            variant="contained"
            className={classes.applyAndReset}
            onClick={handleResetSort}
          >
            <SortIcon className={classes.uploadIcon} />
            <Typography variant="body1" className={classes.buttonsTypo}>
              {FILTER.RESET_SORT}
            </Typography>
          </Button>
        </CustomTooltip>
      </Box>
    </Root>
  );
};

ResetAndApplyButton.propTypes = {
  handleApplyFilter: PropTypes.func.isRequired,
  handleResetSort: PropTypes.func.isRequired,
};
export default ResetAndApplyButton;
